<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>Skycons</h1>
					<p waBody="m" waText>Skycons &mdash; 10 animated weather glyphs rendered on HTML5 Canvas elements. Includes clear day/night, rain, snow, sleet, wind, fog, cloudy, and partly cloudy icons with configurable colour.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">Skycons 1.0.0</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						<wa-tag pill variant="neutral">Canvas</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:skycons</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.plugins.skycons</p>
					<p waBody="s" waText>Built on: Skycons 1.0.0</p>
				</div>
				<wa-details summary="Installation">
					<div class="wa-stack wa-gap-xs">
						@if (!useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
								<markdown [data]="mdContent_649" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
						@if (useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
								<markdown [data]="mdContent_650" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<h2 waHeading="l" waText>Components &#40;4&#41;</h2>
					<p waBody="m" waText>Click any component to see its full API &mdash; properties, constructors, methods, events, slots, and examples.</p>
					<div class="wa-grid wa-gap-s" style="--min-column-size:18rem;">
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>Skycon</h4>
								<p waBody="s" waColorText="quiet" waText>CRTP Canvas-based animated weather icon component. Renders weather glyphs using HTML5 Canvas and requestAnimationFrame.</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">3 props</wa-tag>
									<wa-tag pill variant="neutral">5 methods</wa-tag>
									<wa-tag pill variant="success">2 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/skycons/skycon']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>SkyIcon</h4>
								<p waBody="s" waColorText="quiet" waText>Enum of 10 animated weather icon types. Values render as lowercase hyphenated strings &#40;e.g. clear-day, partly-cloudy-night&#41;.</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">4 props</wa-tag>
									<wa-tag pill variant="neutral">1 methods</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/skycons/sky-icon']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>SkyconPageConfigurator</h4>
								<p waBody="s" waColorText="quiet" waText>Page configurator that auto-registers the skycons JavaScript library via npm. Implements IPageConfigurator.</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">1 props</wa-tag>
									<wa-tag pill variant="neutral">4 methods</wa-tag>
									<wa-tag pill variant="success">2 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/skycons/skycon-page-configurator']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>SkyconOptions</h4>
								<p waBody="s" waColorText="quiet" waText>CRTP options class for skycon configuration &mdash; colour and resizeClear settings.</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">2 props</wa-tag>
									<wa-tag pill variant="neutral">2 methods</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/skycons/skycon-options']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
					</div>
				</div>
				<wa-details summary="Features (6)">
					<div class="wa-stack wa-gap-xs">
						<p waBody="s" waColorText="quiet" waText>10 animated weather icons &mdash; Canvas-based weather glyphs with smooth animation</p>
						<p waBody="s" waColorText="quiet" waText>HTML5 Canvas rendering &mdash; requestAnimationFrame-driven animation</p>
						<p waBody="s" waColorText="quiet" waText>Configurable colour &mdash; global colour setting via SkyconPageConfigurator</p>
						<p waBody="s" waColorText="quiet" waText>SkyIcon enum &mdash; type-safe weather icon selection with 10 values</p>
						<p waBody="s" waColorText="quiet" waText>Skycon component &mdash; CRTP Canvas-based icon with fluent API</p>
						<p waBody="s" waColorText="quiet" waText>Zero configuration &mdash; auto-registered via ServiceLoader SPI</p>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Examples (1)">
					<div class="wa-stack wa-gap-m">
						<div class="wa-stack wa-gap-xs">
							<h4 waHeading="s" waText>Create animated weather icons</h4>
							<p waBody="s" waColorText="quiet" waText>Use the Skycon component with the SkyIcon enum.</p>
							<markdown [data]="mdContent_651" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="Quick Start">
					<markdown [data]="mdContent_652" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="SPI Extension Point Details (1)">
					<div class="wa-stack wa-gap-s">
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">IPageConfigurator</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>SkyconPageConfigurator auto-registers skycons JS via npm</p>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="SPI Extension Points">
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
						</div>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Prerequisites">
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://darkskyapp.github.io/skycons/</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/JWebMP</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>